import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Wrench, Loader2, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const mxn = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2 })}`;

// Ventas guardadas en una sucursal distinta a la del cajero (bug previo: caían en la sucursal almacén) → moverlas en bloque.
export default function RepararVentas({ onDone }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const cargar = useCallback(() => { api.get("/ventas/reparar-sucursal").then((r) => setD(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  useEffect(() => { cargar(); }, [cargar]);

  async function reparar() {
    if (!window.confirm(`¿Mover ${d.total_ventas} ventas a la sucursal de su cajero (misma caja)? Se ajusta el stock y queda auditoría de cada una.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/ventas/reparar-sucursal", { confirmar: true });
      toast.success(`${data.movidas} ventas reubicadas${data.errores.length ? ` · ${data.errores.length} con error` : ""}`);
      cargar(); onDone?.();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }

  if (!d) return null;
  return (
    <div className={`rounded-2xl border p-4 space-y-3 ${d.total_ventas ? "border-rose-300 bg-rose-50/60" : "border-brand-line"}`} data-testid="reparar-ventas">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-brand-ink"><Wrench className="w-4 h-4 text-brand-amber" /> Ventas en la sucursal equivocada <span data-testid="reparar-total" className={`chip h-5 px-1.5 text-[10px] ${d.total_ventas ? "chip-red" : "chip-emerald"}`}>{d.total_ventas}</span></div>
        {d.total_ventas > 0 && <button data-testid="reparar-btn" disabled={busy} onClick={reparar} className="btn-ink h-9 px-3 text-xs">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Wrench className="w-3.5 h-3.5" />} Mover a la sucursal del cajero</button>}
      </div>
      {d.total_ventas === 0 ? <p className="text-xs text-brand-muted flex items-center gap-1"><CheckCircle2 className="w-3.5 h-3.5 text-emerald-600" /> Todas las ventas están en la sucursal de su cajero; cada caja verá sus ventas y podrá hacer su corte.</p> : (
        <div className="text-xs space-y-1" data-testid="reparar-resumen">
          <p className="text-brand-muted">Estas ventas no aparecen en la caja de su sucursal ni entran al corte. Al moverlas conservan su caja (Caja 01/02/03).</p>
          {d.resumen.map((r, i) => <div key={i} className="flex justify-between gap-3 border-t border-rose-200/60 pt-1"><span><strong>{r.cajero}</strong>: {r.de} → <strong>{r.a}</strong></span><span>{r.ventas} ventas · {mxn(r.total)}</span></div>)}
        </div>
      )}
    </div>
  );
}
